import { render, staticRenderFns } from "./ColorPickerComponent.vue?vue&type=template&id=673bfaa5"
import script from "./ColorPickerComponent.vue?vue&type=script&lang=js"
export * from "./ColorPickerComponent.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerComponent.vue?vue&type=style&index=0&id=673bfaa5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports